import React, { FC, useRef, useState } from 'react';
import _ from 'lodash';
import { addComma } from 'src/utils/common';
import { dateFormat } from 'src/utils/dateSet';
import { contentModalViewStore } from 'src/store/modal';
import CompanyDetail from 'src/components/molecules/table/CompanyDetail';
import IconButton from 'src/components/atoms/buttons/IconButton';
import { useQueryClient } from '@tanstack/react-query';
import { getMemberInfo } from 'src/utils/common';
import { errorModalViewStore, loadingModalViewStore, confirmModalViewStore } from 'src/store/modal';
import { fetchDeletePreworkData } from 'src/fetch/stepB';
import { preworkDataStore, initPreworkPayload } from 'src/store/preworkInfo';
import { getBizNo } from 'src/utils/charSet';

export const gridOption = (data: any, orgData: any, totalCount: number, bindStateData: any) => {
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  const setConfirmModalState = confirmModalViewStore((state: any) => state.set);
  const closeModalState = confirmModalViewStore((state: any) => state.close);
  const bindPreworkParam = preworkDataStore((state: any) => state.param);
  const bindPreworkBindParam = preworkDataStore((state: any) => state.bindParam);
  const userInfoData: any = getMemberInfo();

  const gridData = _.cloneDeep(data) || [];
  //
  const setContentModalState = contentModalViewStore((state: any) => state.set);
  const disableEvent = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  const gridFnc = {
    viewContent: (param: any) => {
      const co_id = param[0] || '';
      const prev_co_num = param[1] || '';
      const start_date = param[2] || '';
      const prev_co_name = param[3] || '';

      const data =
        orgData.find(
          (item: any) =>
            item.co_id === co_id &&
            item.prev_co_num === prev_co_num &&
            item.start_date === start_date
        ) || {};

      const viewModal = (e: any) => {
        const payload = {
          active: '_active',
          title: prev_co_name,
          content: <CompanyDetail type="list" data={data} />,
          styleDef: { width: '1024px' },
        };
        setContentModalState(payload);
      };
      return (
        <div className="_custom_div_center" style={{ width: '45px', height: '45px' }}>
          <IconButton
            clickEvent={e => viewModal(e)}
            icon="ri-file-list-line"
            type="type3"
            styleDef={{ fontSize: '15px', width: '28px', height: '28px' }}
          />
        </div>
      );
    },
    deleteContent: (param: any) => {
      const co_id = param[0] || '';
      const prev_co_num = param[1] || '';
      const start_date = param[2] || '';
      const prev_co_name = param[3] || '';

      const viewModal = (e: any) => {
        setConfirmModalState({
          active: '_active',
          content: (
            <div className="_title">
              <div className="_main">{prev_co_name}</div>
              <div className="_sub">해당 내용을 삭제하시겠습니까?</div>
            </div>
          ),
          cancleEvt: () => {
            closeModalState({ content: null, active: '' });
          },
          confirmEvt: () => {
            const param: any = {};
            param.acct_year = userInfoData.acct_year;
            param.co_cd = userInfoData.co_cd;
            param.co_id = co_id;
            param.prev_co_num = prev_co_num;
            param.start_date = start_date;

            fetchDeletePreworkData(param, queryClient, errorModalState, loadingState, () => {
              closeModalState({ content: null, active: '' });
              const initialSeq = bindPreworkParam.initialSeq || 0;
              bindPreworkBindParam({ initialSeq: initialSeq + 1 });
              setContentModalState({
                active: '',
              });
            });
          },
        });
      };

      return (
        <div className="_custom_div_center" style={{ width: '45px', height: '45px' }}>
          <IconButton
            clickEvent={e => viewModal(e)}
            icon="ri-delete-bin-2-line"
            type="type3"
            styleDef={{ fontSize: '15px', width: '28px', height: '28px' }}
          />
        </div>
      );
    },
    createDate: (param: any) => {
      return dateFormat(param[0], 'YYYY.MM.DD HH:mm');
    },
    defDate: (param: any) => {
      return dateFormat(param[0], 'YYYY.MM.DD');
    },
    viewCount: (param: any) => {
      const count = param[0] || 0;
      return addComma(count);
    },
    viewBizNum: (param: any) => {
      const value = param[0] || '0';
      return getBizNo(value);
    },
  };

  // gridData
  const gridOption = {
    label: [
      {
        label: '',
        col: 'idx',
        width: '0px',
        align: 'left',
        useYN: 'none',
      },
      {
        label: '',
        col: 'co_id',
        width: '0px',
        align: 'left',
        useYN: 'none',
      },
      {
        label: '회사명',
        col: 'prev_co_name',
        width: 'calc(100% - 590px)',
        align: 'left',
        sort: { use: false, active: false, status: 'desc' },
      },
      {
        label: '총소득',
        // label: '급여',
        col: 'Income',
        width: '150px',
        align: 'left',
        sort: { use: false, active: false, status: 'desc' },
        custom: { fn: gridFnc.viewCount, param: ['totalIncome'] },
        // custom: { fn: gridFnc.viewCount, param: ['income'] },
      },
      {
        label: '사업자등록번호',
        col: 'prev_co_num',
        width: '150px',
        align: 'center',
        sort: { use: false, active: true, status: 'desc' },
        custom: { fn: gridFnc.viewBizNum, param: ['prev_co_num'] },
      },
      {
        label: '근무시작일',
        col: 'start_date',
        width: '100px',
        align: 'center',
        sort: { use: false, active: false, status: 'desc' },
        custom: {
          fn: gridFnc.defDate,
          param: ['start_date'],
        },
      },
      {
        label: '근무종료일',
        col: 'end_date',
        width: '100px',
        align: 'center',
        sort: { use: false, active: false, status: 'desc' },
        custom: {
          fn: gridFnc.defDate,
          param: ['end_date'],
        },
      },
      {
        label: '',
        col: '',
        width: '35px',
        align: 'center',
        sort: { use: false, active: false, status: 'desc' },
        custom: {
          fn: gridFnc.viewContent,
          param: ['co_id', 'prev_co_num', 'start_date', 'prev_co_name'],
        },
      },
      {
        label: '',
        col: '',
        width: '35px',
        align: 'center',
        sort: { use: false, active: false, status: 'desc' },
        custom: {
          fn: gridFnc.deleteContent,
          param: ['co_id', 'prev_co_num', 'start_date', 'prev_co_name'],
        },
      },
    ],
    styleDef: { width: '100%', fontSize: '13px' },
    data: gridData,
    totalCount: totalCount,
  };

  return gridOption;
};
